import React, { ReactElement, useState } from 'react'
import Image from 'next/image'
import { copyToClipboard, uni1d800 } from '@/utils/extras'
import Link from 'next/link'
import { BiLogoTelegram } from 'react-icons/bi'
import { BsTwitterX } from 'react-icons/bs'
import { GrMail } from 'react-icons/gr'
import { cidv1FromCidv0Url, shortenAddress } from '@/utils/shortenAddress'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

const HelpOverview = (): ReactElement => {
    const [showTooltip, setShowTooltip] = useState(false)
    const [showTooltip1, setShowTooltip1] = useState(false)
    const [showTooltip2, setShowTooltip2] = useState(false)

    const [isOpen, setIsOpen] = useState(Array(20).fill(false))

    const toggleSection = (index: number) => {
        setIsOpen((prev) => {
            const newOpen = [...prev]
            newOpen[index] = !newOpen[index]
            return newOpen
        })
    }

    return (
        <div>
            <h1 className="title">F.A.Q.</h1>
            <h2 className="title">Contact</h2>
            <Link href="https://t.me/CRAZY_414/" target="_blank" rel="noopener noreferrer">
                <BiLogoTelegram className="social-media-icon margin-top-five gray border large-icon" />
                &nbsp;
            </Link>
            <Link href="https://www.x.com/yourtokenart" target="_blank" rel="noopener noreferrer">
                <BsTwitterX className="social-media-icon margin-top-five gray border large-icon z-index-hundred" />
                &nbsp;
            </Link>
            <Link href="mailto:yourtoken.art@gmail.com" target="_blank" rel="noopener noreferrer">
                <GrMail className="social-media-icon margin-top-five gray border large-icon z-index-hundred" />
            </Link>
            <br />
            <br />
            <h2 className="title red">
                The CRAZY DeFi NFT Marketplace is currently under development and can only be used for testing purposes.
                <br />
                Do not use the platform to transfer the CRAZY token until the platform is live.
            </h2>
            <h2 className="title" onClick={() => toggleSection(0)} style={{ cursor: 'pointer' }}>
                What is the&nbsp;
                <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                &nbsp;token?
                {isOpen[0] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[0] && (
                <div>
                    <div className="centered-text">
                        <span className="gray">
                            The token has the name&nbsp;
                            <br />
                            <i> United States Deputy Secretary of the Interior</i>
                            <br />
                            and symbol&nbsp;
                            <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                            &nbsp;
                            <br />
                            This token was created by the
                            <a
                                className={'blue'}
                                href="https://www.youtube.com/@mariarahelvarnhagen2729/streams"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <b>&nbsp;Atropa&nbsp;developer&nbsp;</b>
                            </a>
                            on PulseChain and might have future use in the
                            <a
                                className={'blue'}
                                href="https://t.me/atropapulsechain"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <b>&nbsp;Atropa&nbsp;eco-system</b>
                            </a>
                            .
                        </span>
                        <br />
                        <p>
                            <span className="gray">
                                At launch the developer put all &quot;666&quot; CRAZY tokens in a V1 LP together with
                                the ⱏⱟⰿⰺⰹⱓⱒ (aqa NoNukes) token. This LP was then burned.
                            </span>
                        </p>
                        <span className="gray">It is one of many &quot;666&quot; meme tokens launched.</span>
                        <p>
                            <span className="gray">
                                Here is an overview of all
                                <a
                                    className={'blue'}
                                    href="https://docs.google.com/spreadsheets/d/18bPzn_T0EMv1reTz5ct6OZIomLu7fEOmAncSsSsyRlk/edit?gid=0#gid=0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <b>&nbsp;Atropa&nbsp;tokens</b>
                                </a>
                                .
                            </span>
                        </p>
                        <br />
                    </div>
                    <a
                        className={'blue'}
                        href="https://bafybeicb2hlad6zs4kc4yvn5xbbzti6krjtpoxrysg42d4e5s5oubbipum.ipfs.dweb.link/#/token/0x9C3D2c93993F196AAC232ede26321B95F5702545"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <b>&nbsp;Token details</b>
                    </a>
                    <p>
                        <a
                            className={'blue'}
                            href="https://dexscreener.com/pulsechain/0x73ec3eec5b447c7e51d5751577f7cf6371030ce3"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <b>&nbsp;Dexscreener Chart</b>
                        </a>
                    </p>
                    <br />
                </div>
            )}
            <h2 className="title" onClick={() => toggleSection(14)} style={{ cursor: 'pointer' }}>
                How to buy the&nbsp;
                <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                &nbsp;token?
                {isOpen[14] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[14] && (
                <div>
                    <p>
                        <span className="gray">
                            <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                            &nbsp;lives on
                        </span>
                        <a
                            className={'blue'}
                            href="https://gopulse.com/x?in=0x174a0ad99c60c20d9b3d94c3095bc1fb9ddefd62&out=0x9C3D2c93993F196AAC232ede26321B95F5702545"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <b>&nbsp;PulseChain&nbsp;</b>
                        </a>

                        <span className="gray">at this address</span>
                    </p>
                    <p>
                        <span>
                            <Image
                                src="/hexagon-copy.svg"
                                alt="arrow"
                                width={15}
                                height={15}
                                style={{
                                    marginLeft: '1px',
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    copyToClipboard('0x9C3D2c93993F196AAC232ede26321B95F5702545', setShowTooltip1)
                                }
                            />
                        </span>
                        {!showTooltip1 && (
                            <span className={'gray'}>
                                &nbsp;{shortenAddress('0x9C3D2c93993F196AAC232ede26321B95F5702545')}
                            </span>
                        )}
                        {showTooltip1 && (
                            <span
                                className={'gray'}
                                style={{
                                    visibility: showTooltip1 ? 'visible' : 'hidden',
                                    opacity: showTooltip1 ? 1 : 0,
                                    transition: 'opacity 0.5s ease-in-out',
                                }}
                            >
                                &nbsp;Copied!
                            </span>
                        )}
                    </p>
                    <br />
                    <p className="gray">The best route with the thickest liquidity pools is to: </p>
                    <p className="gray">
                        Buy
                        <a className={'blue'} href="https://gopulse.com/buy" target="_blank" rel="noopener noreferrer">
                            <b>&nbsp;Pulse&nbsp;</b>
                        </a>
                        (PLS) first.
                    </p>
                    <p className="gray">
                        Swap PLS for&nbsp;
                        <span>
                            <Image
                                src="/hexagon-copy.svg"
                                alt="arrow"
                                width={15}
                                height={15}
                                style={{
                                    marginLeft: '1px',
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    copyToClipboard('0x174a0ad99c60c20d9b3d94c3095bc1fb9ddefd62', setShowTooltip)
                                }
                            />
                            <Link href={cidv1FromCidv0Url('0x174a0ad99c60c20d9b3d94c3095bc1fb9ddefd62')} />
                            <a
                                className={'blue'}
                                href="https://gopulse.com/x?out=0x174a0ad99c60c20d9b3d94c3095bc1fb9ddefd62"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <b>&nbsp;ⱏⱟⰿⰺⰹⱓⱒ&nbsp;</b>
                            </a>
                            <span
                                className="gray"
                                style={{
                                    visibility: showTooltip ? 'visible' : 'hidden',
                                    opacity: showTooltip ? 1 : 0,
                                    transition: 'opacity 0.5s ease-in-out',
                                }}
                            >
                                &nbsp;Copied!
                            </span>
                        </span>
                    </p>
                    <p>
                        <br />
                        <span className="gray">
                            and then swap this for&nbsp;
                            <span>
                                <Image
                                    src="/hexagon-copy.svg"
                                    alt="arrow"
                                    width={15}
                                    height={15}
                                    style={{
                                        marginLeft: '1px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                        copyToClipboard('0x9C3D2c93993F196AAC232ede26321B95F5702545', setShowTooltip2)
                                    }
                                />
                                <Link href={cidv1FromCidv0Url('0x9C3D2c93993F196AAC232ede26321B95F5702545')} />
                                <a
                                    className={'blue'}
                                    href="https://gopulse.com/x?in=0x174a0ad99c60c20d9b3d94c3095bc1fb9ddefd62&out=0x9C3D2c93993F196AAC232ede26321B95F5702545"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className={uni1d800.className + ' '}>
                                        {'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                                    </span>
                                </a>
                                <span className="gray">.</span>
                                <span
                                    className="gray"
                                    style={{
                                        visibility: showTooltip2 ? 'visible' : 'hidden',
                                        opacity: showTooltip2 ? 1 : 0,
                                        transition: 'opacity 0.5s ease-in-out',
                                    }}
                                >
                                    &nbsp;Copied!
                                </span>
                            </span>
                        </span>
                    </p>
                    <br />
                    <p className="gray">An overview of all liquidity pools can be looked up here</p>
                    <p>
                        <a
                            className={'blue'}
                            href="https://liquidity-pools.vercel.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <b>&nbsp;PulseChain Liquidity Pools&nbsp;</b>
                        </a>
                    </p>
                    <span className="gray">
                        <br />
                        <i className={'black red'}>DISCLAIMERS&nbsp;</i>
                        <br />
                        <i>The developer repeatedly stated that it is NOT recommended to buy &quot;666&quot; tokens.</i>
                        <br />
                        <i>
                            {' '}
                            - The Atropa developer owns very little of them and is not involved in developing this
                            platform.
                        </i>
                        <br />
                        <i>
                            {' '}
                            - For now they are called meme coins. Future utility (if any) in layer 2 Dysnomia is
                            unclear.
                        </i>
                        <br />
                        <i> - The tokens have low liquidity pools.</i>
                        <br />
                        <i> - While CRAZY cannot be minted, ⱏⱟⰿⰺⰹⱓⱒ can be freely minted by the developer only.</i>
                        <br />
                        <i> - This gives him the power to suppress the CRAZY dollar price.</i>
                    </span>
                    <br />
                </div>
            )}
            <h2 className="title" onClick={() => toggleSection(16)} style={{ cursor: 'pointer' }}>
                What is the CRAZY NFT marketplace all about?
                {isOpen[16] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[16] && (
                <div className="centered-text gray">
                    The goal of this platform is to experiment with CRAZY and give it utility while we wait for the
                    fruition of Dysnomia/Atropa.
                    <br />
                    This platform is being developed by the community and the Atropa developer was not involved at all.
                    <br />
                    Utility is created by associating the token with a limited supply of CRAZY NFT&apos;s.
                    <br />
                    Each NFT has two token bound wallets. One for the owner and one (called the vault) controlled by the
                    NFT contract.
                    <br />
                    The incentive to hold CRAZY is huge.
                    <br />
                    - The token gives you voting rights on which NFT is minted next.
                    <br />
                    - The NFT can only be bought with CRAZY. Part of that sale is redistributed to voters and claimers.
                    <br />
                    - Holding an NFT gives you claim power. Which is the accumulation of votes on the NFT.
                    <br />
                    - A claim can only be made by sending an equivalent amount of CRAZY to the NFT.
                    <br />
                    This is a unique and innovative way of what you could call a form of &quot;active&quot; staking.
                </div>
            )}
            <h2 className="title" onClick={() => toggleSection(15)} style={{ cursor: 'pointer' }}>
                What is the&nbsp;
                <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                &nbsp;NFT?
                {isOpen[15] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[15] && (
                <div>
                    <div className="centered-text">
                        <span className="gray">
                            The NFT contract is deployed here
                            <br />
                            The contract is unique and innovative.
                            <br />
                            - It contains the regular ERC-721 NFT contract.
                            <br />
                            - It keeps track of tokenomics and claims per NFT.
                            <br />
                            - It registers two token bound wallet addresses.
                            <br />
                            - It has additional marketplace functions for registered marketplaces.
                            <br />
                            <br />
                            - The first wallet is fully controlled by the NFT owner and needs to be funded with CRAZY to
                            be able to claim.
                            <br />
                            - The second wallet is called the Vault. It holds the CRAZY token that was distributed upon
                            a sale or was sent by claimers.
                            <br />
                            - An NFT owner can decide to claim a vault. Claim power (originally determined by the amount
                            of voters) is permanently reduced by each claim until it is sold, after which it is reset
                            for the new owner.
                            <br />
                            - By executing a claim you send CRAZY token from the token bound owner wallet to it&apos;s
                            own vault wallet and that of the NFT vault you want to claim. The exact ratio is set by the
                            tokenomics upon creation.
                            <br />
                            - A claim gives a proportionally right to be part of the distribution of the vault contents
                            upon the NFT sale.
                            <br />
                            - The tokenomics are chosen by the creator before minting.
                            <br />
                            - The vault contents is distributed when the NFT is sold.
                            <br />
                            - A fixed percentage is transferred to the former owner.
                            <br />
                            - The rest is distributed proportionally to the claimers, who then need to reclaim the
                            vault.
                            <br />- Part of the sale is placed in the vault.
                        </span>
                    </div>
                </div>
            )}
            <h2 className="title" onClick={() => toggleSection(17)} style={{ cursor: 'pointer' }}>
                What are the&nbsp;
                <span className={uni1d800.className + ' '}>{'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}</span>
                &nbsp; NFT tokenomics?
                {isOpen[17] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[17] && (
                <div>
                    <div className="centered-text">
                        <span className="gray">
                            Each NFT can have it&apos;s own unique tokenomics set initially by the creator of the NFT.
                            <br />
                            They can be viewed in the tokenomics tab when you scroll down in the NFT details page
                            <br />
                            Each sale is done with the CRAZY token and the proceeds can be distributed as follows.
                            <br />
                            <br />
                            - DAO fee <br />
                            (Is minimal 5% to cover costs of running the platform or fund AI agents in the future)
                            <br />
                            <br />
                            - Current owner <br /> (Put this at maximum to make this a regular NFT sale. Initially there
                            is no owner)
                            <br />
                            <br />
                            - Creator Royalty <br />
                            (The original creator can have part of each sale)
                            <br />
                            <br />
                            - Burn <br /> (Part of the sale can be used to burn CRAZY or another token)
                            <br />
                            <br />
                            - Airdrop <br />
                            (The Airdrop is distributed to those who interact on X; see the AIRDROP tab)
                            <br />
                            <br />
                            - Distributed Claims <br />
                            (Part of the sale is distributed proportionally to the claimers)
                            <br />
                            <br />
                            - Treasury <br />
                            (Can be used by the platform in a variety of ways to attract more users to the platform)
                        </span>
                    </div>
                </div>
            )}
            <br />

            <h2 className="title" onClick={() => toggleSection(2)} style={{ cursor: 'pointer' }}>
                Community engagement
                {isOpen[2] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[2] && (
                <div className="centered-text gray">
                    <br />
                    Proposing your Art for minting is fun because it can be any topic. Art, personal statements,
                    advertisement, news etc.
                    <br />
                    Voting is exciting because only the highest voted proposal gets minted.
                    <br />
                    Your voting rights increases with your CRAZY holding.
                    <br />
                    A freshly minted NFT is not owned and is put on a forced auction. Bidding starts at 0 so anyone has
                    a chance to buy them with CRAZY.
                    <br />
                    Every mint is published on X where anyone can apply for an airdrop on forced auctions.
                    <br />
                    Proceeds are distributed to the community, but it&apos;s exact tokenomics for each NFT can be freely
                    chosen by the creator.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(3)} style={{ cursor: 'pointer' }}>
                How does the Your Art tab work?
                {isOpen[3] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[3] && (
                <div className="centered-text gray">
                    Here you can suggest your own art to be minted as NFT.
                    <br />
                    You can upload any image (jpeg or png). But first give it a title and a description.
                    <br />
                    You need to double check if the final result is correct before hitting the &quot;Propose NFT
                    Mint&quot; button.
                    <br />
                    Your Art at this point is not yet an NFT, but it will be published on Telegram as an NFT proposal.
                    <br />
                    It will also be visible in the Mint tab where the community can vote for it.
                    <br />
                    You can skip the proposal button and do it later in the Portfolio tab.
                    <br />
                    Advertisement is allowed, but uploading sensitive or adult content is not. They can be reported and
                    will be removed.
                    <br />
                    <br />
                    Another fun and unique aspect is finetuning tokenomics per NFT by the creator.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(4)} style={{ cursor: 'pointer' }}>
                How does the Mint tab work?
                {isOpen[4] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[4] && (
                <div className="centered-text gray">
                    A countdown shows when the next NFT is minted.
                    <br />
                    Use Vote Power to vote on any NFT proposal.
                    <br />
                    The NFT with the most votes wins the mint.
                    <br />
                    Your vote is not consumed, but returned after the NFT is minted.
                    <br />
                    You can also revoke your vote and use it for a different proposal.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(5)} style={{ cursor: 'pointer' }}>
                How does the Auction tab work?
                {isOpen[5] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[5] && (
                <div className="centered-text gray">
                    Here all NFT&apos;s currently up for auction are listed.
                    <br />
                    Each auction ends after the countdown ends.
                    <br />
                    The person with the highest bid wins the NFT.
                    <br />
                    You can only bid with CRAZY tokens. These are send to a custodial wallet until the auction is over.
                    <br />
                    Bids can be increased during auction, but not decreased.
                    <br />
                    Part of the sale can be claimed by others holding an NFT.
                    <br />
                    A freshly minted NFT is put on Forced Auction as there is no owner yet.
                    <br />
                    A Forced Auction is announced on Telegram and X. Where you can apply for an individual airdrop.
                    <br />
                    Checkout the exact tokenomics in the tab below. They are fine-tuned by the creator.
                    <br />
                    Others tabs show more details, like the NFT owner wallet address and details about the vault wallet.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(6)} style={{ cursor: 'pointer' }}>
                How does the Market tab work?
                {isOpen[6] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[6] && (
                <div className="centered-text gray">
                    Here all NFT&apos;s are listed that are currently on sale or not for sale.
                    <br />
                    An NFT on sale can be directly bought if your bid meets the sale price.
                    <br />
                    You can also do an offer on NFT&apos;s that are not for sale.
                    <br />
                    An offer or bid has a minimal of 12 and maximum of 168 hours expiration.
                    <br />
                    Each auction ends after the countdown ends.
                    <br />
                    An offer or bid can only be done with the CRAZY token.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(7)} style={{ cursor: 'pointer' }}>
                How does the Your Vote/Claims/Portfolio tab&apos;s work?
                {isOpen[7] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[7] && (
                <div className="centered-text gray">
                    Here you can see you vote and claim histories.
                    <br />
                    The portfolio hold&apos;s NFT&apos;s or Art you own or created.
                    <br />
                    Art you previously uploaded can be proposed for minting.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(8)} style={{ cursor: 'pointer' }}>
                How does the Airdrop tab work?
                {isOpen[8] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[8] && (
                <div className="centered-text gray">
                    Here a list of NFT&apos;s are shown where you can apply for an Airdrop.
                    <br />
                    You can apply on X by Following, Liking, Retweeting, Tagging and reply with your wallet address.
                    <br />
                    Part (up to 90%) of the NFT sale will be distributed as airdrop, depending on the NFT tokenomics.
                    <br />
                    You can apply for multiple NFT&apos;s.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(9)} style={{ cursor: 'pointer' }}>
                What gives a CRAZY NFT value?
                {isOpen[9] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[9] && (
                <div className="centered-text gray">
                    As a CRAZY NFT owner you hold Art created by anyone from the community and can be anything special.
                    <br />
                    At the time of minting a CRAZY NFT was the most popular voted art by the community.
                    <br />
                    The total amount of votes gives it Claim Power. Use it to partly claim upcoming NFT sales.
                    <br />
                    Each NFT is an unique piece of art, very popular and has &apos;active staking&apos; utility.
                    <br />
                    Each NFT has it&apos;s own unique tokenomics set by the creator.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(10)} style={{ cursor: 'pointer' }}>
                What is Vote Power?
                {isOpen[10] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[10] && (
                <div className="centered-text gray">
                    Your Vote Power depends directly on the amount of CRAZY tokens you hold.
                    <br />
                    Vote Power gives you the right to vote on any NFT proposal in the Mint tab.
                    <br />
                    Voting is free and does not consume CRAZY tokens.
                    <br />
                    Your vote is valuable as it makes you eligible to earn part of the NFT sale.
                    <br />
                    How much you receive depends on how much you voted and the specific NFT tokenomics.
                    <br />
                    Your vote is forfeited when you do not hold enough CRAZY tokens to represent it.
                </div>
            )}
            <br />
            <h2 className="title" onClick={() => toggleSection(11)} style={{ cursor: 'pointer' }}>
                What is Claim Power?
                {isOpen[11] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[11] && (
                <div className="centered-text gray">
                    Each CRAZY NFT has Claim Power. How much differs per NFT. It is the amount of votes it received upon
                    winning the mint.
                    <br />
                    Your total Claim Power is the sum of all CRAZY NFT&apos;s Claim Power you hold.
                    <br />
                    With Claim Power you can claim part of the sales of any NFT. Earnings go to the NFT holder who
                    claimed with it.
                    <br />
                    <b>
                        Claims are only valid at the time of sale when the holder has enough CRAZY tokens to represent
                        the claim.
                    </b>
                    <br />
                    This means without holding CRAZY Tokens your claims are worthless.
                    <br />
                    How much yield you receive depends on how much you claimed and the specific NFT tokenomics.
                    <br />
                    Be very selective of how much and which NFT you want to claim.
                    <br />
                    Contrary to a vote, <b>a claim is irrevocable</b> and always belong to the original NFT.
                    <br />
                    This means that if the NFT is transferred, the claims also move with it and the new owner will
                    receive the yield.
                </div>
            )}
            <br />
            <br />
            <h2 className="title" onClick={() => toggleSection(12)} style={{ cursor: 'pointer' }}>
                How was the platform developed?
                {isOpen[12] ? (
                    <FiChevronUp style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                ) : (
                    <FiChevronDown style={{ verticalAlign: 'middle', lineHeight: '1' }} />
                )}
            </h2>
            {isOpen[12] && (
                <div className="centered-text gray">
                    The platform is developed from scratch by a devoted community member called YourToken.art on
                    Telegram.
                </div>
            )}
            <br />
        </div>
    )
}

export default HelpOverview
